import { defineComponent } from 'vue';
import { formatSize, msToTime, isTruePlayFormat, checkIsJSON, parseTime, isMagnetURL, toast } from '@remote/utils';
import { mapState, mapGetters, useStore } from 'vuex';
import { USER_DOWNLOAD, USER_DOWNLOAD_URL, SPEC_TXT } from '@remote/constant';
import debounce from 'lodash/debounce';
import { getIconFromMineType } from '@remote/utils/static-icons';
import SpeedTackIcon from '@shared/assets/img/trying.png';
import MeetIcon from '@shared/assets/img/team.png';
import Icons from '@remote/utils/static-icons';
import SpeedUp from '@remote/components/SpeedUp.vue';
import { stat } from '@remote/utils/stat';
import { getExtensionFromFilename, categorizeByFileExtension } from '@shared/utils/file';
import { openPopBTTaskDetail } from '@remote/utils/dialog';
import { safeJSONParse } from '@shared/utils';
import { request } from '@remote/api/request';
import { useEnvStore } from '@remote/store/env';
import { useDeviceStore } from '@remote/store/device';
const MapPhase = {
  'PHASE_TYPE_ERROR': 'restore2',
  'PHASE_TYPE_PENDING': 'pause2',
  'PHASE_TYPE_RUNNING': 'pause2',
  'PHASE_TYPE_COMPLETE': 'check',
  'pause': 'down2',
  'running': 'pause2',
  'delete': 'warn-nav'
};
const MapSpec = {
  'pause': 'PHASE_TYPE_PENDING',
  'running': 'PHASE_TYPE_RUNNING',
  'delete': 'PHASE_TYPE_ERROR'
};
const MapSpecTxt = {
  'pause': '已暂停',
  'running': '等待中',
  'delete': '已删除',
  'PHASE_TYPE_PENDING': '等待中',
  'PHASE_TYPE_ERROR': '',
  'PHASE_TYPE_COMPLETE': ''
};
export default defineComponent({
  name: 'FileItem',
  components: {
    SpeedUp
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  setup() {
    return {
      store: useStore()
    };
  },
  data() {
    return {
      unread: false,
      iShowHuddle: true,
      MeetIcon,
      SpeedTackIcon,
      isOpeningBTDetail: false
    };
  },
  computed: {
    ...mapState(['all', 'isSelect', 'taskType', 'tasks', 'tasksDone', 'selects', 'isShowVipPop', 'teamNumber', 'teamLeftTimes', 'huddleNum', 'teamTaskId', 'showLastCount', 'platform', 'isMiniProgram', 'files']),
    ...mapGetters(['curList', 'isVip', 'vipType', 'runningList', 'isYSvip', 'showVip', 'appCanPlay', 'isSuperVip']),
    vipTeamJoined() {
      return this.file.params.team_isjoined === 'true' && this.file.phase === 'PHASE_TYPE_RUNNING';
    },
    svipJoined() {
      // 超会加速时展示超会闪电图标
      return this.file.phase === 'PHASE_TYPE_RUNNING' && this.file.params.super_speedup_isjoined === 'true';
    },
    isInTrySpeed() {
      return this.$store.state.trySpeedStatus === 'TRYING';
    },
    iShowHuddlePop() {
      return this.id === this.teamTaskId && this.iShowHuddle && this.taskType === 'ing' && this.huddleNum && this.teamLeftTimes < 1 && !this.vipTeamJoined && this.showVip;
    },
    file() {
      return this.all[this.id];
    },
    isChecked() {
      return this.isSelect && this.selects.includes(this.id);
    },
    phase() {
      return this.file.phase;
    },
    spec() {
      const spec = (this.file.params.spec || '').match(/(delete|pause|running)/);
      return spec && this.phase !== 'PHASE_TYPE_ERROR' ? spec[0] : '';
    },
    specStatus() {
      const status = (this.file.params.status || '').match(/(delete|pause|running)/);
      return status && this.phase !== 'PHASE_TYPE_ERROR' ? status[0] : '';
    },
    status() {
      let specIcon = '';
      const isUpdating = this.spec && this.spec !== this.specStatus;
      if (this.file.updating || isUpdating) specIcon = 'loading';
      return this.isSelect || this.phase === 'PHASE_TYPE_COMPLETE' ? this.isChecked ? 'checked' : 'check' : specIcon || MapPhase[this.specStatus || this.phase];
    },
    taskSpeedUp() {
      try {
        return JSON.parse(this.file.params.speedup);
      } catch (e) {
        return {
          p2p: '',
          vip: '',
          super: ''
        };
      }
    },
    isWarn() {
      return this.phase === 'PHASE_TYPE_ERROR';
    },
    warnInfo() {
      var _this$file$params$err;
      if (checkIsJSON(this.file.params.error)) {
        var _safeJSONParse$error, _this$file;
        return (_safeJSONParse$error = safeJSONParse((_this$file = this.file) === null || _this$file === void 0 || (_this$file = _this$file.params) === null || _this$file === void 0 ? void 0 : _this$file.error).error) !== null && _safeJSONParse$error !== void 0 ? _safeJSONParse$error : '';
      }
      return (_this$file$params$err = this.file.params.error) !== null && _this$file$params$err !== void 0 ? _this$file$params$err : this.file.message;
    },
    size() {
      if (this.taskType === 'file' && this.file.kind === 'drive#folder') return '';
      return this.file.file_size !== '0' ? formatSize(this.file.file_size || Number(this.file.size)) : '未知大小';
    },
    progress() {
      return Number(this.file.progress || 0);
    },
    speed() {
      return Number(this.file.params.speed || 0);
    },
    speedupCount() {
      return Number(this.file.params.speedup_count);
    },
    outdated() {
      const now = Date.now();
      const d = now - new Date(this.file.updated_time).getTime();
      return d > 15 * 60 * 1000;
    },
    speedTxt() {
      const isUpdating = this.spec && this.spec !== this.specStatus;
      if (this.file.phase === 'PHASE_TYPE_COMPLETE') return '';
      if (this.file.updating || isUpdating) return `${SPEC_TXT[this.file.update_action || this.spec]}中`;
      const showSpeed = this.outdated ? '' : formatSize(this.speed) + '/s';
      return this.spec && this.spec !== 'running' ? MapSpecTxt[this.spec] : this.phase === 'PHASE_TYPE_RUNNING' ? showSpeed : MapSpecTxt[this.phase];
    },
    lastTime() {
      return this.speed > 0 && this.progress > 0 && this.phase === 'PHASE_TYPE_RUNNING' ? ' / 约' + msToTime(Number(this.file.file_size) * (100 - this.progress) * 0.01 / (this.speed + this.speedupSpeed)) : '';
    },
    speedBackground() {
      // return this.file.type === USER_DOWNLOAD_URL ? 2 : 1 // && this.status === 'pause1'
      return this.isVip || this.isInTrySpeed ? 2 : 1;
    },
    speedupSpeed() {
      return Number(this.file.params.speedup_speed || 0);
    },
    speedVip() {
      return this.isVip ? '(+' + formatSize(this.speedupSpeed) + '/s)' : '';
    },
    iShowlight() {
      return this.isVip && this.file.type === USER_DOWNLOAD && this.phase === 'PHASE_TYPE_RUNNING' && this.speedupSpeed !== 0 && this.isInTrySpeed;
    },
    isBt() {
      // TODO: 当前只能根据图标来判断
      // return this.file.icon_link.indexOf('636aabac9eee211de3beb7cfe72eb25538a88e39') > 0
      return isMagnetURL(this.file.params.url || '');
    },
    isFolder() {
      var _this$file$params$rea, _this$file$params$rea2;
      return ((_this$file$params$rea = this.file.params.real_path) !== null && _this$file$params$rea !== void 0 ? _this$file$params$rea : '').endsWith('/') || ((_this$file$params$rea2 = this.file.params.real_path) !== null && _this$file$params$rea2 !== void 0 ? _this$file$params$rea2 : '').endsWith('\\');
    },
    iconLink() {
      return this.isBt && Icons.bt || this.file.icon_link || getIconFromMineType(this.file.mime_type);
    },
    showCheckBtn() {
      // TODO: 文件未做编辑操作
      return ['ing', 'done'].includes(this.taskType);
    },
    total_file_count() {
      return this.file.params && this.file.params.total_file_count ? Number(this.file.params.total_file_count) : 0;
    },
    speedup_failed_count() {
      return this.file.params && this.file.params.speedup_failed_count ? Number(this.file.params.speedup_failed_count) : 0;
    },
    // 判断任务里面是否含有敏感资源
    isTaskWithSensitiveResource() {
      return this.total_file_count > 0 && this.speedup_failed_count > 0 && this.isVip;
    },
    isAllTaskWithSensitiveResource() {
      return this.isTaskWithSensitiveResource && this.total_file_count === this.speedup_failed_count;
    },
    /**
     *  任务对应的文件是否已经删除
     */
    isTaskDeleted() {
      var _this$file2;
      return ((_this$file2 = this.file) === null || _this$file2 === void 0 || (_this$file2 = _this$file2.params) === null || _this$file2 === void 0 ? void 0 : _this$file2.is_deleted) === 'true';
    }
  },
  watch: {
    progress(val) {
      if (val && val === 100) {
        this.store.commit('delete', this.id);
      }
    },
    phase(val, oVal) {
      if (val !== oVal && val === 'PHASE_TYPE_RUNNING' && this.huddleNum > 0 && this.file.type === USER_DOWNLOAD_URL && !this.isYSvip) {
        setTimeout(() => this.store.dispatch('checkHuddle', this.file), 1000);
      }
    },
    vipTeamJoined(val) {
      if (val && this.huddleNum > 0 && this.showLastCount && !this.isYSvip && this.teamLeftTimes > 0) {
        this.store.commit('toast', `任务组队成功，组队次数剩余${this.teamLeftTimes - 1}次`);
        this.store.commit('update', {
          showLastCount: false
        });
      }
    }
  },
  methods: {
    parseTime,
    lessHuddle() {
      const huddleNum = this.huddleNum - 1;
      this.store.commit('update', {
        huddleNum
      });
      localStorage.setItem('huddleNum', String(huddleNum));
    },
    skipHuddlePop() {
      this.store.commit('update', {
        isShowVipPop: true
      });
      this.lessHuddle();
    },
    handleWarn() {
      const msg = this.isAllTaskWithSensitiveResource ? '暂无法加速' : '部分子文件暂无法加速';
      this.store.commit('toast', msg);
    },
    huddleQuit() {
      this.iShowHuddle = false;
      this.lessHuddle();
    },
    async showFolder() {
      try {
        if (this.isOpeningBTDetail) return;
        this.isOpeningBTDetail = true;
        await this.store.dispatch('getFiles', {
          parent_id: this.file.file_id,
          name: this.file.name,
          with: this.taskType === 'ing' ? [`taskID.${this.file.id}`] : ''
        });
        // 旧版本套件适配：
        // v < 3.6 task不会返回file_id，不会弹窗，不用单独适配；
        // v > 3.6 && v < 3.7 task会返回file_id，前端会请求files接口，会带with参数，但是套件端会忽略with参数正常返回下载中已完成列表；但是弹窗后，浮层里的删除、添加（旧版本不支持，新版本支持）入口需要labels区分展示，
        if (this.files.length > 0) {
          await openPopBTTaskDetail({
            rootFileName: this.file.file_name,
            rootFileID: this.file.file_id,
            taskID: this.file.id
          });
          // this.store.commit('update', { showFilePop: true, filePopTaskID: this.file.id })
        } else {
          this.store.commit('update', {
            parentIds: []
          });
          if (this.file.phase === 'PHASE_TYPE_COMPLETE') {
            toast('该目录下无文件，请检查文件是否存在');
          } else if (['PHASE_TYPE_RUNNING', 'PHASE_TYPE_PAUSED'].includes(this.file.phase)) {
            toast('该任务尚未有完成下载的文件，请稍后再试');
          }
        }
        this.isOpeningBTDetail = false;
      } catch (error) {
        console.error(error);
        this.isOpeningBTDetail = false;
      }
    },
    formatSize,
    async handleSelect(e) {
      if (this.$refs.speedUp) {
        const el = this.$refs.speedUp;
        if (el.contains(e.target)) return;
      }
      if (this.isSelect) {
        this.store.commit('selTask', this.file.id);
        if (this.selects.length === 0) {
          this.store.commit('update', {
            isSelect: false
          });
        }
      } else if (e.target.nodeName === 'A') {
        this.handleFile();
      } else if (this.file.file_id) {
        // 这里原来是文件夹的的处理逻辑，现在不管是不是文件夹，都走这里，后面else分支用来兜底
        // if (this.platform === 'hiksemi') return this.handleOpenFile()
        if (this.isTaskDeleted) return;
        const deviceStore = useDeviceStore();
        if (this.taskType === 'done') {
          try {
            var _deviceStore$currentD, _this$file$params$inf, _this$file$params$url;
            const file = await ((_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.deviceFetch('drive/v1/files/' + this.file.file_id, {}));
            this.$stat({
              action: 'completed_task_click',
              data: {
                task_type: 'btfolder',
                gcid: this.file.params.hash,
                info_hash: (_this$file$params$inf = this.file.params.info_hash) !== null && _this$file$params$inf !== void 0 ? _this$file$params$inf : '',
                url: (_this$file$params$url = this.file.params.url) !== null && _this$file$params$url !== void 0 ? _this$file$params$url : ''
              }
            });
            this.store.commit('update', {
              files: [],
              parentIds: []
            });
            // XLLite，单文件BT不会创建文件夹，而是直接创建文件
            // 判断出这种情况后，要走消费逻辑
            if ((file === null || file === void 0 ? void 0 : file.kind) === 'drive#file') {
              return this.store.dispatch('getFileInfo', {
                id: this.file.file_id,
                usage: 2,
                action_from: 'completed'
              }).catch(() => {
                toast('播放失败，请检查文件是否存在');
              });
            }
            if ((file === null || file === void 0 ? void 0 : file.kind) === 'drive#folder') {
              this.showFolder();
            }
          } catch (error) {
            toast('获取文件信息失败，请检查文件是否存在');
          }
        } else {
          // 下载中
          // XLLite，单文件BT不会创建文件夹，而是直接创建文件
          // 判断出这种情况后，要走消费逻辑
          try {
            if (this.store.state.curDeviceRunner.space === 'platform#pcxllite' && this.file.params.total_file_count === '1') {
              // 下载中
              const envStore = useEnvStore();
              const data = await request(`drive/v1/files/${this.file.file_id}`, {
                params: {
                  space: envStore.space
                }
              });
              if (data.kind === 'drive#folder') {
                this.showFolder();
              }
            } else {
              this.showFolder();
            }
          } catch (err) {
            var _ref, _err$error_descriptio;
            toast((_ref = (_err$error_descriptio = err.error_description) !== null && _err$error_descriptio !== void 0 ? _err$error_descriptio : err.message) !== null && _ref !== void 0 ? _ref : '获取文件信息失败');
          }
        }
      } else {
        if (this.taskType === 'done') {
          var _this$file$params$inf2, _this$file$params$url2;
          this.$stat({
            action: 'completed_task_click',
            data: {
              task_type: 'file',
              gcid: this.file.params.hash,
              info_hash: (_this$file$params$inf2 = this.file.params.info_hash) !== null && _this$file$params$inf2 !== void 0 ? _this$file$params$inf2 : '',
              url: (_this$file$params$url2 = this.file.params.url) !== null && _this$file$params$url2 !== void 0 ? _this$file$params$url2 : ''
            }
          });
        }
        this.handleOpenFile();
      }
    },
    handleOpenFile: debounce(function () {
      var _this$file3, _this$file$name, _this$file4, _this$file$name2, _this$file5, _task$params, _task$params2, _task$params3, _task$file_name;
      if (this.taskType === 'ing' || this.isTaskDeleted) return;
      // if (this.appCanPlay) return
      const isVideo = (((_this$file3 = this.file) === null || _this$file3 === void 0 || (_this$file3 = _this$file3.mime_type) === null || _this$file3 === void 0 ? void 0 : _this$file3.includes('video')) || isTruePlayFormat((_this$file$name = (_this$file4 = this.file) === null || _this$file4 === void 0 ? void 0 : _this$file4.name) !== null && _this$file$name !== void 0 ? _this$file$name : '')) && !this.isBt;
      const task = this.file;
      stat({
        action: 'complete_file_play_btn_click',
        data: {
          tab: this.taskType === 'ing' ? 'downloading' : 'complete',
          type: categorizeByFileExtension(getExtensionFromFilename((_this$file$name2 = (_this$file5 = this.file) === null || _this$file5 === void 0 ? void 0 : _this$file5.name) !== null && _this$file$name2 !== void 0 ? _this$file$name2 : '')),
          gcid: task === null || task === void 0 || (_task$params = task.params) === null || _task$params === void 0 ? void 0 : _task$params.hash,
          info_hash: task === null || task === void 0 || (_task$params2 = task.params) === null || _task$params2 === void 0 ? void 0 : _task$params2.info_hash,
          url: task === null || task === void 0 || (_task$params3 = task.params) === null || _task$params3 === void 0 ? void 0 : _task$params3.url,
          task_name: task.name,
          task_size: task.file_size,
          file_name: task.name,
          file_size: task.file_size,
          file_extension: getExtensionFromFilename((_task$file_name = task.file_name) !== null && _task$file_name !== void 0 ? _task$file_name : '')
        }
      });
      this.store.dispatch('getFileInfo', {
        id: this.file.file_id,
        type: this.isBt ? 'bt' : '',
        usage: isVideo ? 2 : 0,
        theme: 'light',
        action_from: 'completed',
        scene: 'download_list'
      }).catch(() => {
        toast('播放失败，请检查文件是否存在');
      });
    }, 500, {
      leading: true,
      trailing: false
    }),
    handleSelectInLong() {
      // 暂时注释长按事件，因为此导致底部按钮需点击两次
      if (this.isSelect) return;
      this.store.commit('update', {
        isSelect: true
      });
      this.store.commit('selTask', this.file.id);
    },
    // 右侧按钮点击
    async handleFile() {
      if (this.phase === 'PHASE_TYPE_COMPLETE') {
        if (!this.isSelect) this.store.commit('update', {
          isSelect: true
        });
        this.store.commit('selTask', this.file.id);
      } else if (this.phase === 'PHASE_TYPE_ERROR') {
        var _this$file$params$inf3, _this$file$params$url3;
        // 重试
        this.$stat({
          action: 'downloading_refresh_btn_click',
          data: {
            gcid: this.file.params.hash,
            info_hash: (_this$file$params$inf3 = this.file.params.info_hash) !== null && _this$file$params$inf3 !== void 0 ? _this$file$params$inf3 : '',
            url: (_this$file$params$url3 = this.file.params.url) !== null && _this$file$params$url3 !== void 0 ? _this$file$params$url3 : ''
          }
        });
        await this.store.dispatch('delete', this.file.id);
        let type = USER_DOWNLOAD;
        let file = {
          name: this.file.name,
          size: this.file.file_size,
          file_extension: this.file.file_name.split('.').pop() || ''
        };
        console.log('===fileItem', this.file);
        if (this.file.type === 'user#download-url') {
          file.url = this.file.params.url;
          if (this.file.params.sub_file_index) {
            file.sub_file_index = this.file.params.sub_file_index;
          }
          type = USER_DOWNLOAD_URL;
        } else {
          file.id = this.file.file_id;
        }
        this.store.dispatch('download', {
          file,
          type,
          prevParams: {
            ...this.file.params,
            // 这六个参数不传
            spec: undefined,
            status: undefined,
            retry_times: undefined,
            retry_record: undefined,
            error: undefined,
            speedup: undefined,
            retry_from: this.file.id
          }
        });
      } else {
        // pause, running, delete
        // pending和error的直接调用删除,其他使用pathc更新状态
        if (this.spec === 'delete') return;
        const action = this.spec === 'pause' ? 'running' : 'pause';
        this.store.commit('clearTaskTimer');
        this.store.dispatch('actionTask', {
          id: this.file.id,
          action
        });
      }
    }
  }
});